import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { StyledText } from '../Shared/StyledText';
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator';

const PaymentInfoWrapper = styled.div`
    background-color: #fff;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    padding: 16px;
    height: fit-content;
`;

const LeftSide = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    height: 100%;
`;

const RightSide = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
`;

const StatusRow = styled.div`
    display: flex;
    align-items: center;
    margin-top: 4px;
`;

const CheckIcon = styled(FontAwesomeIcon)`
    color: #0D812E;
    margin-right: 8px;
    font-size: 16px;
`;

export const PaymentInfo = props => {
    const { currentBalance, paidUpLabel, balanceLabel, amountSubscriptLabel, loading } = props;

    const getBalanceColor = () => {
        if (currentBalance < 0) {
            return '#0D812E'; // Green for credit
        } else if (currentBalance > 0) {
            return '#9E2506'; // Red for owing
        } else {
            return '#001414'; // Dark gray for zero
        }
    };

    const getPaidUpLabel = () => {
        if (paidUpLabel) {
            return paidUpLabel;
        }
    };

    const getAmountSubscriptLabel = () => {
        if (amountSubscriptLabel) {
            return amountSubscriptLabel
        }
        if (currentBalance < 0) {
            return '(Credit)';
        } else if (currentBalance > 0) {
            return 'Owing';
        } else {
            return '';
        }
    };

    const showCheckmark = () => {
        return currentBalance <= 0 && paidUpLabel;
    };

    return (
        <PaymentInfoWrapper>
            {loading ? (
                <LoadingIndicator loading={loading} />
            ) : (
                <>

                    <LeftSide>
                        <StyledText
                            fontWeight="bold"
                            fontSize="20px"
                            color="#1f2937"
                        >
                            {balanceLabel}
                        </StyledText>
                        {showCheckmark() && (
                            <StatusRow>
                                <CheckIcon icon={faCheckCircle} />
                                <StyledText
                                    fontWeight="normal"
                                    fontSize="16px"
                                    color="#152828"
                                >
                                    {getPaidUpLabel()}
                                </StyledText>
                            </StatusRow>
                        )}
                    </LeftSide>
                    <RightSide>
                        <StyledText
                            fontWeight="bold"
                            fontSize="20px"
                            color={getBalanceColor()}
                        >
                            ${currentBalance.toFixed(2)}
                        </StyledText>

                        <StyledText
                            fontWeight={currentBalance < 0 ? "bold" : "normal"}
                            fontSize="16px"
                            marginTop="4px"
                            color={getBalanceColor()}
                        >
                            {getAmountSubscriptLabel()}
                        </StyledText>
                    </RightSide>
                </>
            )}
        </PaymentInfoWrapper>
    )
}